const ResourceId = {
  LIBRARY: "library",
  SEASON: "season",
  PRODUCT: "product",
  CUSTOMER: "customer",
  SETTING: "setting",
  USER: "user",
  ORDER: "order",
  FABRIC: "fabric",
  DASHBOARD: "dashboard",
  REPORT: "report",
  SIZE: "size"
};

export default ResourceId;
